/** Sentinel row standing for the empty assignment set; never sent to the API. */
export const NO_RESTRICTED_LOCATIONS_ID = 'NO_RESTRICTED_LOCATIONS';
